<div class="bmc-view-delta__detail" *ngIf="item">
  <div class="table-scroll">
    <table class="bz-table bmc-view-delta__table">
      <thead>
        <tr>
          <th class="bz-table__cell bmc-view-delta__td-left">{{ 'VIEW_DELTA.DIFFERENCE_TYPE' | translate }}</th>
          <th class="bz-table__cell bmc-view-delta__td-left">{{ 'VIEW_DELTA.PROPERTY' | translate }}</th>
          <th class="bz-table__cell bmc-view-delta__td-left">{{ 'VIEW_DELTA.PACKAGE_VALUE' | translate }}</th>
          <th class="bz-table__cell bmc-view-delta__td-left">{{ 'VIEW_DELTA.CURRENT_VALUE' | translate }}</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let comparison of item?.comparisionList; let i = index; trackBy: trackByIndex">
          <td class="bz-table__cell">
            <div class="text-ellipsis"
                 [class.expanded]="isExpanded(i, 'type')"
                 [class.clickable]="isClickable(i, 'type')"
                 [attr.data-cell-key]="i + '-type'"
                 (click)="toggleCell(i, 'type')"
                 [attr.title]="isExpanded(i, 'type') ? null : ('VIEW_DELTA.DIFFERENCE_TYPES.' + comparison?.type.trim().toUpperCase() | translate)">
              {{ 'VIEW_DELTA.DIFFERENCE_TYPES.' + comparison?.type.trim().toUpperCase() | translate }}
            </div>
          </td>
          <td class="bz-table__cell">
            <div class="text-ellipsis"
                 [class.expanded]="isExpanded(i, 'jsonPath')"
                 [class.clickable]="isClickable(i, 'jsonPath')"
                 [attr.data-cell-key]="i + '-jsonPath'"
                 (click)="toggleCell(i, 'jsonPath')"
                 [attr.title]="isExpanded(i, 'jsonPath') ? null : comparison?.jsonPath">
              {{ comparison?.jsonPath }}
            </div>
          </td>
          <td class="bz-table__cell">
            <div class="text-ellipsis"
                 [class.expanded]="isExpanded(i, 'packageValue')"
                 [class.clickable]="isClickable(i, 'packageValue')"
                 [attr.data-cell-key]="i + '-packageValue'"
                 (click)="toggleCell(i, 'packageValue')"
                 [attr.title]="isExpanded(i, 'packageValue') ? null : comparison?.packageValue">
              {{ comparison?.newValue }}
            </div>
          </td>
          <td class="bz-table__cell">
            <div class="text-ellipsis"
                 [class.expanded]="isExpanded(i, 'currentValue')"
                 [class.clickable]="isClickable(i, 'currentValue')"
                 [attr.data-cell-key]="i + '-currentValue'"
                 (click)="toggleCell(i, 'currentValue')"
                 [attr.title]="isExpanded(i, 'currentValue') ? null : comparison?.currentValue">
              {{ comparison?.currentValue }}
            </div>
          </td>
        </tr>
        <tr *ngIf="item?.comparisionList && item.comparisionList.length === 0">
          <td class="bz-table__cell" colspan="4">{{ 'VIEW_DELTA.NO_RESULTS' | translate }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
